import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {SiteService} from "./site.service";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface SiteCreateInputModel {
  projectId: string;
}

@Component({
  templateUrl: "./site-create-dialog.template.pug",
  providers: [
    SiteService,
  ],
})
export class SiteCreateDialogComponent extends DialogComponent<SiteCreateInputModel, boolean>
  implements SiteCreateInputModel {
  projectId: string;
  public error: Error;
  public siteName: string;

  static showCreateDialog(dialogService: DialogService, input: SiteCreateInputModel): Promise<boolean> {
    return dialogService.showDialog(SiteCreateDialogComponent, input) as Promise<boolean>;
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async save(): Promise<void> {
    await this.siteService.saveSite({name: this.siteName, projectId: this.projectId});
    this.result = true;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    public siteService: SiteService,
  ) {
    super(dialogService);
  }
}
